import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [staff, setStaff] = useState(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    if (!localStorage.getItem("intechify_token")) { setChecking(false); return; }
    api.get("/auth/me").then((response) => setStaff(response.data)).catch(() => localStorage.removeItem("intechify_token")).finally(() => setChecking(false));
  }, []);
  const signIn = (data) => { localStorage.setItem("intechify_token", data.token); setStaff(data.staff); };
  const signOut = () => { localStorage.removeItem("intechify_token"); setStaff(null); };
  return <AuthContext.Provider value={{ staff, checking, signIn, signOut }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);